import * as React from 'react';
export const IcFaq = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5 2a9.49 9.49 0 00-8.59 13.54l-.56 3.39a1.49 1.49 0 001.72 1.72l3.39-.56A9.5 9.5 0 1012.5 2zm0 15.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1.77-5.36c-.66.42-.77.54-.77.86a1 1 0 11-2 0 2.93 2.93 0 011.69-2.55c.65-.41.81-.56.81-.95a1.5 1.5 0 10-3 0 1 1 0 11-2 0 3.5 3.5 0 117 0 2.999 2.999 0 01-1.73 2.64z'
      fill='currentColor'
    />
  </svg>
);
